import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputBase from "@mui/material/InputBase";
import { makeStyles } from "components/mui-core";
import { DateLabel } from "components-redesign/DateLabel/DateLabel";
import InputLabel from "components-redesign/InputLabel";
import { commonClasses } from "components-redesign/styles";
import { ISOstring } from "model/modelTypes";
import { ReactComponent as CalendarIcon } from "icons/redesign/datePicker/calendar.svg";
import { forwardRef } from "react";

const useStyles = makeStyles()({
  datePickerValue: {
    fontSize: "14px",
    color: "#3C4858",
    letterSpacing: "0.15px",
  },
  datePickerPlaceholder: {
    color: "#a2a2a2",
  },
});

interface PresetsTriggerProps {
  label?: string;
  displayLabel: string | null;
  startTime: ISOstring | null;
  endTime: ISOstring | null;
  valueLabelMask: string;
  placeholder: string;
  showTime: boolean;
  error?: string;
  helperText?: string;
  disabled: boolean;
  onClick: () => void;
}

const PresetsTrigger = forwardRef<HTMLDivElement, PresetsTriggerProps>(
  (
    {
      label,
      displayLabel,
      startTime,
      endTime,
      valueLabelMask,
      placeholder,
      showTime,
      error,
      helperText,
      disabled,
      onClick,
    },
    ref
  ) => {
    const { classes: styles } = useStyles();

    return (
      <FormControl
        fullWidth
        disabled={disabled}
        error={!!error}>
        {label && <InputLabel error={!!error}>{label}</InputLabel>}
        <div
          ref={ref}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            minWidth: "200px",
          }}>
          <CalendarIcon />
          <InputBase
            readOnly
            onClick={onClick}
            sx={{
              ...commonClasses.inputValue,
              ...commonClasses.inputUnderline,
              cursor: "pointer",
              width: "100%",
              "& .MuiInputBase-input": {
                cursor: "pointer",
                padding: "1.8px 14px 7.5px 0px",
              },
            }}
            inputComponent={() =>
              displayLabel ? (
                <span className={styles.datePickerValue}>{displayLabel}</span>
              ) : (
                <div>
                  {!!startTime && !!endTime ? (
                    <div style={{ display: "flex", gap: "4px" }}>
                      <DateLabel
                        date={startTime}
                        mask={valueLabelMask}
                        utc
                        className={styles.datePickerValue}
                      />
                      {showTime && (
                        <DateLabel
                          date={startTime}
                          mask="hour:min"
                          utc
                          className={styles.datePickerValue}
                        />
                      )}
                      {" - "}
                      <DateLabel
                        date={endTime}
                        mask={valueLabelMask}
                        utc
                        className={styles.datePickerValue}
                      />
                      {showTime && (
                        <DateLabel
                          date={endTime}
                          mask="hour:min"
                          utc
                          className={styles.datePickerValue}
                        />
                      )}
                    </div>
                  ) : (
                    <span className={styles.datePickerPlaceholder}>
                      {placeholder} {" - "} {placeholder}
                    </span>
                  )}
                </div>
              )
            }
          />
        </div>
        {(helperText || error) && (
          <FormHelperText error={!!error}>{error || helperText}</FormHelperText>
        )}
      </FormControl>
    );
  }
);

export default PresetsTrigger;
